import { Cart } from 'shopify-types'

import type { CartFieldsFragment } from '../__generated/storefront'
import { mapGQLMoneyToMoney } from '../graphql'
import { mapGQLProductVariantToProductVariant } from '../product/graphql'

export type GQLCart = CartFieldsFragment

export const mapGQLCartToCart = (cart: GQLCart): Cart => ({
  id: cart.id,
  checkoutUrl: cart.checkoutUrl,
  totalQuantity: cart.totalQuantity,
  cost: {
    checkoutChargeAmount: mapGQLMoneyToMoney(cart.cost.checkoutChargeAmount),
    totalAmount: mapGQLMoneyToMoney(cart.cost.totalAmount),
  },
  lines: cart.lines.edges.map(edge => ({
    ...edge.node,
    merchandise: mapGQLProductVariantToProductVariant(edge.node.merchandise),
  })),
  buyerIdentity: {
    email: cart.buyerIdentity.email ?? undefined,
    // Needed by the cart rehydration market check in cartStore
    countryCode: cart.buyerIdentity.countryCode ?? undefined,
    customer: cart.buyerIdentity.customer
      ? {
          id: cart.buyerIdentity.customer.id,
          email: cart.buyerIdentity.customer.email ?? '',
        }
      : undefined,
  },
  appliedGiftCards: cart.appliedGiftCards.map(giftCard => ({
    ...giftCard,
    amountUsed: mapGQLMoneyToMoney(giftCard.amountUsed),
    balance: mapGQLMoneyToMoney(giftCard.balance),
  })),
  discountCodes: cart.discountCodes,
  attributes: cart.attributes.map(attribute => ({
    key: attribute.key,
    value: attribute.value ?? undefined,
  })),
})

export type GQLBuyerIdentityInput = Readonly<{
  customerAccessToken?: string
  email?: string
  phone?: string
}>
